export default __webpack_public_path__ + "static/media/courier-tracking-car.8f7582ae.svg";